require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-justice-reinvestment.json") })
        }
      }, "path---tags-justice-reinvestment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-justice-reinvestment!./.cache/json/tags-justice-reinvestment.json
// module id = 1014
// module chunks = 231608221292675